import { Request } from "../Request";
import { BASE_URL } from "../../constants/urls";

export const saveSport = async (data: any) => {
  return Request.post("/sport", { data: data });
};

export const getSport = async (id: any) => {
  return Request.get(`/sport/${id}`, {});
};

export const getSportDetails = async (id: any) => {
  return Request.get(`/sports/get-sport/${id}`, { noAuth: true });
};

export const getAll = async () => {
  return Request.get(`/sport`, {});
};

export const getCount = async () => {
  return Request.get(`/sports/get-count`, {});
};

export const deleteSport = async (id: any) => {
  return Request.del(`/sport/${id}`, {});
};
export const getActive = async () => {
  return Request.get(`/sports/get-active`, { noAuth: true });
};

export const updateSport = async (id: any, data: any) => {
  return Request.put(`/sport/${id}`, { data: data });
};

export async function uploadImage(image: File) {
  const formData = new FormData();
  formData.append("image", image);
  try {
    const response = await fetch(`${BASE_URL}/media`, {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      alert("Something went wrong! Try Again.");
    }
  } catch (error) {
    alert("Something went wrong! Try Again.");
  }
}
